module.exports = __webpack_public_path__ + "img/img_56.8e1da52a.png";